export const areNotEqual = (current, next) => next !== current;

export const isNowTrue = (current, next) => !current && next === true;
